<div class="owner">
    <div class="mat-elevation-z2 owner_info" [class.one-column]="widgetData.width===1">
        <div class="owner_info-data">
            <lucide-icon [name]="widgetData.options_dict.person? 'user-star' : 'building-2'"></lucide-icon>
            <span class="owner_info-label">
              {{ (widgetData.options_dict.person ? 'MODALS.TEXT.PERSON' : 'MODALS.TEXT.PROJECT') | translate }}
                : {{ this.ownerName || widgetData.content.owner_guid }}
          </span>
        </div>
        <div class="owner_info-actions">
            <button mat-raised-button class="owner_info-actions-button" (click)="showPaymentHistory()"
                    [matTooltip]="'WIDGETS.ETF_BILL.TOOLTIPS.EXECUTE_PAYMENT'|translate">
                <lucide-icon name="banknote-arrow-down"></lucide-icon>
            </button>
            <button mat-raised-button class="owner_info-actions-button" (click)="showPaymentHistory()"
                    [matTooltip]="'WIDGETS.ETF_BILL.TOOLTIPS.ACCOUNT_DEPOSIT'|translate">
                <lucide-icon name="banknote-arrow-up"></lucide-icon>
            </button>
            <button mat-raised-button class="owner_info-actions-button" (click)="showPaymentHistory()"
                    [matTooltip]="'WIDGETS.ETF_BILL.TOOLTIPS.ACCOUNT_HISTORY'|translate">
                <lucide-icon name="history"></lucide-icon>
            </button>
        </div>
    </div>

    <div class="mat-elevation-z2 owner_info">
        <div class="owner_info-data">
            <lucide-icon name="wallet" style="margin-bottom: 4px;"></lucide-icon>
            <span class="owner_info-label">
              {{ 'WIDGETS.ETF_BILL.LABELS.BALANCE'|translate }}
                : {{ widgetData.content.total| currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
          </span>
        </div>
    </div>

</div>

<div class="finance_data">
    <div class="finance_data-header">
        <div class="finance_data-header-label">{{ 'WIDGETS.ETF_BILL.LABELS.MOVEMENTS'|translate }}</div>
        <span class="finance_data-header-button">{{ 'WIDGETS.ETF_BILL.LABELS.APPROVED'|translate }}</span>
        <span class="finance_data-header-button">{{ 'WIDGETS.ETF_BILL.LABELS.PROMISED'|translate }}</span>
    </div>
    <div class="finance_data-item mat-elevation-z2">
        <div class="finance_data-item-label">{{ 'WIDGETS.ETF_BILL.LABELS.DEPOSITS'|translate }}</div>
        <button class="finance_data-item-button" mat-raised-button>
            {{ widgetData.content.recipient.APPROVED | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
        </button>
        <button class="finance_data-item-button" mat-raised-button>
            {{ widgetData.content.recipient.PROMISED | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
        </button>
    </div>

    <div class="finance_data-item mat-elevation-z2">
        <div class="finance_data-item-label">{{ 'WIDGETS.ETF_BILL.LABELS.WITHDRAWLS'|translate }}</div>
        <button class="finance_data-item-button" mat-raised-button>
            {{ widgetData.content.payer.APPROVED * -1 | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
        </button>
        <button class="finance_data-item-button" mat-raised-button>
            {{ widgetData.content.payer.PROMISED * -1 | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
        </button>
    </div>
    <div class="finance_data-footer">
        <div class="finance_data-footer-label">{{ 'WIDGETS.ETF_BILL.LABELS.TOTAL'|translate }}</div>
        <button class="finance_data-footer-button" mat-raised-button>
            {{ (widgetData.content.recipient.APPROVED - widgetData.content.payer.APPROVED) | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
        </button>
        <button class="finance_data-footer-button" mat-raised-button>
            {{ (widgetData.content.recipient.PROMISED - widgetData.content.payer.PROMISED) | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
        </button>
    </div>
    <div class="finance_data-footer" style="margin-top: 10px;">
        <div class="finance_data-footer-label">{{ 'WIDGETS.ETF_BILL.LABELS.FORECAST'|translate }}</div>
        <button class="finance_data-footer-button"
                matBadgePosition="above before"
                [matBadge]="(widgetData.content.recipient.APPROVED - widgetData.content.payer.APPROVED) / widgetData.content.total *100 | currency : '%' : 'symbol' : '1.2-2' : 'ru' "
                mat-raised-button>
            {{ (widgetData.content.total + (widgetData.content.recipient.APPROVED - widgetData.content.payer.APPROVED)) | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
        </button>
        <button class="finance_data-footer-button"
                [matBadge]="((widgetData.content.recipient.APPROVED - widgetData.content.payer.APPROVED) + (widgetData.content.recipient.PROMISED - widgetData.content.payer.PROMISED)) / widgetData.content.total *100 | currency : '%' : 'symbol' : '1.2-2' : 'ru' "
                matBadgePosition="above before"
                mat-raised-button>
            {{ (widgetData.content.total + (widgetData.content.recipient.APPROVED - widgetData.content.payer.APPROVED) + (widgetData.content.recipient.PROMISED - widgetData.content.payer.PROMISED)) | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' }}
        </button>
    </div>
</div>